// Опис карток для екрана деталей (CardDetailScreen). «Дитяча» — дослівно
// зі скріншотів monobank; решта написані за тим самим шаблоном. Картинки
// вирізані в public/card-detail; обкладинка в усіх — жовта картка.
// Секція: { emoji? (картинка) | emojiText? (символ), title, text?, items?: [{ icon, text }] }
const ICON = (name) => `/card-detail/${name}.png`;
const HERO = ICON('kids-hero');
const FREE = 'Випуск: безкоштовно';
const footnote = (cta) => `Натискаючи «${cta}»,\nви погоджуєтеся з умовами продукту`;

const CARD_DETAILS = {
  kids: {
    title: 'Дитяча картка',
    hero: HERO,
    info: {
      title: 'Для клієнтів від 6 до 14 років',
      text: 'Діти вчаться фінансової грамотності, а батьки — контролюють витрати. Все відкривається онлайн, а плати за обслуговування немає',
    },
    sections: [
      {
        emoji: ICON('emoji-child'),
        title: 'Дитина зможе:',
        items: [
          { icon: ICON('pay'), text: 'Оплачувати телефоном за допомогою Apple Pay та Google Pay' },
          { icon: ICON('cashback'), text: 'Отримувати до 20% кешбеку' },
          { icon: ICON('heart'), text: 'Колекціонувати одяг для віртуального кота та скіни для картки' },
        ],
      },
      {
        title: 'Додатково',
        text: 'А якщо замовите пластикову картку - дитина отримає ще й ексклюзивний конструктор від mono',
      },
      {
        emoji: ICON('emoji-lock'),
        emojiClass: 'lock',
        title: 'Батьки зможуть:',
        items: [
          { icon: ICON('receipt'), text: 'Бачити всі витрати дитини у власній виписці' },
          { icon: ICON('phone'), text: 'Отримувати сповіщення про них' },
          { icon: ICON('check'), text: 'І навіть обмежувати їх у бажаних категоріях, якщо треба' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Випуск віртуальної картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Поповнення та перекази- безкоштовні' },
          { icon: ICON('plastic'), text: 'Випуск пластикової картки - 100 грн' },
          { icon: ICON('cash'), text: 'Зняття готівки - 0,9%' },
        ],
      },
    ],
    cta: { title: 'Хочу дитячу картку', sub: FREE },
    footnote: footnote('Хочу дитячу картку'),
  },

  evidnovlennia: {
    title: 'єВідновлення',
    hero: HERO,
    info: {
      title: 'Для отримання компенсації за житло',
      text: 'Картка для коштів за державною програмою єВідновлення. Гроші йдуть на ремонт пошкодженого житла: будматеріали та роботи підрядників. Відкривається онлайн, обслуговування безкоштовне',
    },
    sections: [
      {
        emojiText: '🏠',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('topup'), text: 'Отримати компенсацію, призначену в Дії, одразу на картку' },
          { icon: ICON('receipt'), text: 'Купувати будівельні матеріали в магазинах-учасниках програми' },
          { icon: ICON('check'), text: 'Оплачувати роботи підрядників, зареєстрованих у програмі' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Кошти програми мають цільове призначення, тому зняти їх готівкою чи переказати на іншу картку не вийде',
      },
      {
        emojiText: '📋',
        title: 'Як отримати:',
        items: [
          { icon: ICON('phone'), text: 'Подайте заяву на компенсацію в Дії' },
          { icon: ICON('virtual'), text: 'Відкрийте картку єВідновлення в застосунку monobank' },
          { icon: ICON('check'), text: 'Після рішення комісії кошти надійдуть на картку' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Випуск картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Зарахування компенсації - безкоштовне' },
          { icon: ICON('pay'), text: 'Оплата будматеріалів і робіт - без комісії' },
        ],
      },
    ],
    cta: { title: 'Хочу картку єВідновлення', sub: FREE },
    footnote: footnote('Хочу картку єВідновлення'),
  },

  diia: {
    title: 'Дія.Картка',
    hero: HERO,
    info: {
      title: 'Для державних виплат',
      text: 'Одна картка для всіх виплат і допомоги, які ви оформлюєте в Дії. Все відкривається онлайн, а плати за обслуговування немає',
    },
    sections: [
      {
        emojiText: '🏛️',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('topup'), text: 'Отримувати державні виплати та допомогу з Дії' },
          { icon: ICON('pay'), text: 'Оплачувати телефоном за допомогою Apple Pay та Google Pay' },
          { icon: ICON('cashback'), text: 'Отримувати кешбек за покупки' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Щоб виплати надходили саме сюди, оберіть Дія.Картку від monobank як рахунок для виплат у застосунку Дія',
      },
      {
        emojiText: '🔔',
        title: 'Завжди під контролем:',
        items: [
          { icon: ICON('phone'), text: 'Сповіщення про кожне зарахування' },
          { icon: ICON('receipt'), text: 'Всі виплати окремо у виписці картки' },
          { icon: ICON('check'), text: 'Переказ коштів на будь-яку вашу картку в кілька дотиків' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Випуск віртуальної картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Зарахування виплат - безкоштовне' },
          { icon: ICON('plastic'), text: 'Випуск пластикової картки - 100 грн' },
          { icon: ICON('cash'), text: 'Зняття готівки - 0,9%' },
        ],
      },
    ],
    cta: { title: 'Хочу Дія.Картку', sub: FREE },
    footnote: footnote('Хочу Дія.Картку'),
  },

  white: {
    title: 'Біла картка',
    hero: HERO,
    info: {
      title: 'Для власних коштів',
      text: 'Дебетова картка без кредитного ліміту — тільки ваші гроші. Зручно тримати зарплату чи заощадження окремо від кредитних. Відкривається онлайн за кілька хвилин',
    },
    sections: [
      {
        emojiText: '💳',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('pay'), text: 'Оплачувати телефоном за допомогою Apple Pay та Google Pay' },
          { icon: ICON('cashback'), text: 'Отримувати кешбек у вибраних категоріях' },
          { icon: ICON('topup'), text: 'Отримувати зарплату та перекази' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Можна замовити пластикову картку зі стильним білим дизайном — доставимо Новою поштою або кур\'єром',
      },
      {
        emojiText: '🛡️',
        title: 'Безпека:',
        items: [
          { icon: ICON('phone'), text: 'Сповіщення про кожну операцію' },
          { icon: ICON('check'), text: 'Ліміти на покупки та зняття готівки' },
          { icon: ICON('receipt'), text: 'Заблокувати картку можна в застосунку за секунду' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Випуск віртуальної картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Поповнення та перекази - безкоштовні' },
          { icon: ICON('plastic'), text: 'Випуск пластикової картки - 100 грн' },
          { icon: ICON('cash'), text: 'Зняття готівки - 0,9%' },
        ],
      },
    ],
    cta: { title: 'Хочу білу картку', sub: FREE },
    footnote: footnote('Хочу білу картку'),
  },

  usd: {
    title: 'Доларова картка',
    hero: HERO,
    info: {
      title: 'Для коштів у доларах США',
      text: 'Тримайте заощадження в доларах і розраховуйтесь за кордоном без зайвої конвертації. Купити валюту можна прямо в застосунку',
    },
    sections: [
      {
        emojiText: '💵',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('cash'), text: 'Купувати та продавати долари в застосунку' },
          { icon: ICON('pay'), text: 'Оплачувати покупки в доларах без конвертації' },
          { icon: ICON('topup'), text: 'Отримувати перекази з-за кордону' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Під час подорожей платіть доларовою карткою — гроші списуються без конвертації, а курс видно заздалегідь',
      },
      {
        emojiText: '🌍',
        title: 'За кордоном:',
        items: [
          { icon: ICON('pay'), text: 'Оплата телефоном за допомогою Apple Pay та Google Pay' },
          { icon: ICON('cash'), text: 'Зняття готівки в банкоматах по всьому світу' },
          { icon: ICON('phone'), text: 'Сповіщення про кожну операцію' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Відкриття картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Перекази між своїми картками - безкоштовні' },
          { icon: ICON('plastic'), text: 'Випуск пластикової картки - 100 грн' },
        ],
      },
    ],
    cta: { title: 'Хочу доларову картку', sub: FREE },
    footnote: footnote('Хочу доларову картку'),
  },

  eur: {
    title: 'Єврова картка',
    hero: HERO,
    info: {
      title: 'Для коштів у євро',
      text: 'Тримайте заощадження в євро і розраховуйтесь у Європі без зайвої конвертації. Купити валюту можна прямо в застосунку',
    },
    sections: [
      {
        emojiText: '💶',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('cash'), text: 'Купувати та продавати євро в застосунку' },
          { icon: ICON('pay'), text: 'Оплачувати покупки в євро без конвертації' },
          { icon: ICON('topup'), text: 'Отримувати перекази з-за кордону' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Ідеально для поїздок Європою: платіть у євро напряму і не переплачуйте на подвійній конвертації',
      },
      {
        emojiText: '✈️',
        title: 'У подорожах:',
        items: [
          { icon: ICON('pay'), text: 'Оплата телефоном за допомогою Apple Pay та Google Pay' },
          { icon: ICON('cash'), text: 'Зняття готівки в банкоматах Європи' },
          { icon: ICON('phone'), text: 'Сповіщення про кожну операцію' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Відкриття картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Перекази між своїми картками - безкоштовні' },
          { icon: ICON('plastic'), text: 'Випуск пластикової картки - 100 грн' },
        ],
      },
    ],
    cta: { title: 'Хочу єврову картку', sub: FREE },
    footnote: footnote('Хочу єврову картку'),
  },

  cashback: {
    title: 'Національний кешбек',
    hero: HERO,
    info: {
      title: 'Кешбек за українські товари',
      text: 'Державна програма: купуйте товари українського виробництва й отримуйте за них кешбек. Він нараховується на окрему картку, а відкрити її можна онлайн',
    },
    sections: [
      {
        emojiText: '🇺🇦',
        title: 'Ви зможете:',
        items: [
          { icon: ICON('cashback'), text: 'Отримувати 10% кешбеку за товари з позначкою «Зроблено в Україні»' },
          { icon: ICON('receipt'), text: 'Бачити нарахування в застосунку' },
          { icon: ICON('phone'), text: 'Отримувати сповіщення про зарахування' },
        ],
      },
      {
        title: 'Додатково',
        text: 'Кешбек за покупки нараховується наступного місяця. Обрати картку для програми можна в застосунку Дія',
      },
      {
        emojiText: '🛍️',
        title: 'Кешбек можна витратити на:',
        items: [
          { icon: ICON('receipt'), text: 'Комунальні та поштові послуги' },
          { icon: ICON('heart'), text: 'Ліки, медичні послуги та благодійність' },
          { icon: ICON('check'), text: 'Книги, спорт, концерти та військові облігації' },
        ],
      },
      {
        title: 'Тарифи',
        items: [
          { icon: ICON('virtual'), text: 'Випуск картки та її обслуговування - безкоштовні' },
          { icon: ICON('topup'), text: 'Зарахування кешбеку - безкоштовне' },
        ],
      },
    ],
    cta: { title: 'Хочу Національний кешбек', sub: FREE },
    footnote: footnote('Хочу Національний кешбек'),
  },
};

export const CARD_DETAIL_IMAGES = [
  'kids-hero', 'emoji-child', 'emoji-lock', 'pay', 'cashback', 'heart',
  'receipt', 'phone', 'check', 'virtual', 'topup', 'plastic', 'cash',
].map(ICON);

export default CARD_DETAILS;
